export function swap<T>(
    originalArray: T[] | ReadonlyArray<T>,
    index1: number,
    index2: number
): T[] {
    return originalArray.map((element, i) => {
        if (i === index1) {
            return originalArray[index2];
        }
        if (i === index2) {
            return originalArray[index1];
        }
        return element;
    });
}
